import NodeContentApiSerializer from 'rise-ui/serializers/apis/rise-api/content/node.js';

import { keyForAttribute } from 'rise-ui/utils/serializer/map.js';

@keyForAttribute({
  topic: 'field_select_help_topic',
})
export default class HelpPageSerializer extends NodeContentApiSerializer {}
